import HeaderRepresentation from './HeaderRepresentation';

const Header = () => <HeaderRepresentation />;

export default Header;
